/*------------------------------------*\
    NAVIGATION
\*------------------------------------*/

jQuery(document).ready(function ($) {

    function openMenu()
    {
        $('.main-navigation-container')
            .fadeIn()
            .css("display", "flex")
        $('.main-navigation-navbar').addClass('main-navigation-navbar--open');
    }

    function closeMenu()
    {
        $('.main-navigation-container').fadeOut();
        $('.main-navigation-navbar').removeClass('main-navigation-navbar--open');
    }

    $('.main-navigation-toggle').click(openMenu);
    $('.main-navigation-toggle--close').click(closeMenu);
    $('.content-overlay').click(closeMenu);

    $(document).keyup(function (e) {
        if (e.key === "Escape") {
            closeMenu();
        }
    });

    $('.menu-item-has-children > a').click(function () {
        $(this).parent()
            .toggleClass('sub-menu-open')
            .find('.sub-menu').slideToggle();
    });
});

/*------------------------------------*\
    SITESEARCH
\*------------------------------------*/

import './plugins/searchwp';

jQuery(document).ready(function ($) {
    $('.sitesearch-toggle').click(function () {
        $('.sitesearch-container')
            .fadeIn()
            .addClass('sitesearch-container--open')
            .find('#s').focus();
        $('.sitesearch-overlay')
            .fadeIn()
            .addClass('sitesearch-overlay--open')
    });
});

jQuery(document).ready(function ($) {
    function closeSearch()
    {
        $('.sitesearch-overlay')
            .fadeOut()
            .removeClass('sitesearch-overlay--open')
        $('.sitesearch-container')
            .fadeOut()
            .removeClass('sitesearch-container--open');
    }

    $('.sitesearch-toggle--close').click(closeSearch);
    $('.sitesearch-overlay').click(closeSearch);
});
